"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsPhonePrefill_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsPhonePrefill_Factory = /** @class */ (function () {
    function EFormsPhonePrefill_Factory() {
    }
    EFormsPhonePrefill_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CountryPrefix: model.CountryPrefix,
            Ext: model.Ext,
            Number: model.Number,
            RecordId: model.RecordId,
        };
        return result;
    };
    EFormsPhonePrefill_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CountryPrefix: model.CountryPrefix,
            Ext: model.Ext,
            Number: model.Number,
            RecordId: model.RecordId,
        };
        return result;
    };
    return EFormsPhonePrefill_Factory;
}());
exports.EFormsPhonePrefill_Factory = EFormsPhonePrefill_Factory;
